<script setup lang="ts">
import { capitalize, isEmpty } from 'lodash'
import { useExtendedI18n } from '@/i18n'
import { VTable } from '@/modules/shared/components'
import { AllEntity } from '../types'

defineProps<{
  entities: AllEntity[]
}>()

const formatEntityType = (type: string) => {
  const entity_types = {
    fund: 'Fund',
    spv: 'SPV',
    gp: 'GP',
  }

  return entity_types[type]
}

const { t } = useExtendedI18n()
</script>

<template>
  <div class="mb-5 mt-5 text-xs"></div>
  <VTable
    ref="table"
    :columns="[
      {
        key: 'name',
        name: capitalize(t('shared.name')),
        type: 'string',
        align: 'left',
        is_visible: true,
        fixed: true,
      },
      {
        key: 'legal_name',
        name: capitalize(t('shared.legal name')),
        type: 'string',
        align: 'center',
        is_visible: false,
      },
      {
        key: 'group_name',
        name: capitalize(t('shared.group')),
        type: 'string',
        align: 'center',
        is_visible: true,
      },
      {
        key: 'group_subdomain',
        name: capitalize(t('shared.subdomain')),
        type: 'string',
        align: 'center',
        is_visible: false,
      },
      {
        key: 'entity_type',
        name: capitalize(t('shared.type')),
        type: 'string',
        align: 'center',
        is_visible: true,
      },
      {
        key: 'date_established',
        name: capitalize(t('shared.date established')),
        type: 'date',
        align: 'center',
        is_visible: true,
      },
      {
        key: 'date_added',
        name: capitalize(t('shared.date added')),
        type: 'date',
        align: 'center',
        is_visible: true,
      },
    ]"
    :items="entities"
    name="all-entities"
    :skeleton="entities.length === 0 ? true : false"
    :slots="['name', 'entity_type', 'group.name']"
  >
    <template #name="{ item }">
      <div class="mb-1 flex items-center justify-between">
        <div>
          <RouterLink
            class="hyperlink font-medium text-blue-700 hover:underline"
            :to="{
              name: 'investing.entity-overview',
              params: {
                entity_id: item.id,
                entity_type: item.entity_type,
                slug: item.group_subdomain,
              },
            }"
          >
            {{ item.name }}
          </RouterLink>
        </div>

        <div class="ml-4 border-l border-gray-300 pl-4 text-right">
          <RouterLink
            class="hyperlink text-sm text-gray-600 hover:text-gray-800"
            :to="{
              name: 'tax.entities',
              params: { slug: item.group_subdomain },
            }"
          >
            Taxes
          </RouterLink>
        </div>
      </div>
      <div class="flex flex-wrap items-center justify-start space-x-2">
        <div class="whitespace-normal text-sm text-gray-600" v-if="!isEmpty(item.legal_name)">
          {{ item.legal_name }}
        </div>
      </div>
    </template>
    <template #group_name="{ item }">
      <div>
        {{ item.group_name }}
      </div>
      <div>&lt;{{ item.group_subdomain }}&gt;</div></template
    >
    <template #entity_type="{ item }">
      {{ formatEntityType(item.entity_type) }}
    </template>
  </VTable>
</template>
